import { render, staticRenderFns } from "./GeneratedViroPdfViewer.vue?vue&type=template&id=2afc1242&scoped=true&"
import script from "./GeneratedViroPdfViewer.vue?vue&type=script&lang=ts&"
export * from "./GeneratedViroPdfViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc1242",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
